import React, { useEffect, useState } from "react";
import { Table, Card, Col } from "react-bootstrap";
import { AreaChart, Area, ResponsiveContainer } from 'recharts';
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import { DateRangePicker } from "react-date-range";
import { Modal } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import { enUS } from "date-fns/locale";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "./SalespersonInformation.css";
import API from '../../Utils/Api';
import loader from '../../assests/loader.gif';
import moment from 'moment';
import { QRCodeSVG } from 'qrcode.react';

const transactions = [
  {
    date: "2025-04-14",
    amount: "$100",
    txnNumber: "txn_1RDjUHiXEPfS6ony9fTdQAR",
    bank: "000123456789",
  },
  {
    date: "2025-04-15",
    amount: "$250",
    txnNumber: "txn_1RDjUHiXEPfS6ony9fTdXYZ",
    bank: "000987654321",
  },
  {
    date: "2025-04-16",
    amount: "$400",
    txnNumber: "txn_1RDjUHiXEPfS6ony9fTdLMN",
    bank: "000111222333",
  },
];
const SalespersonInformation = () => {
  const [loading, setLoading] = useState(true);
  const { id } = useParams();


  const [inputslnk, setInputslnk] = useState({ url: '' });

  const [inputs, setInputs] = useState({ id: '', name: '', mobile: '', email: '', city: '', state: '', zip_code: '', street_name: '', w_2_status: 0, payment_setup: 0, profile: '', earned_commission: 0, withdrawal: 0, referred_id: '', referred_name: '' });

  const [mergeddata, setMergeddata] = useState([]);

  const [invitedmerchants, setInvitedmerchants] = useState([]);
  const [linksmer, setLinksmer] = useState([]);
  const [totalrecmer, setTotalrecmer] = useState(0);
  const [perpage, setPerpage] = useState(10);
  const [keyword, setKeyword] = useState('');

  const [sales, setSales] = useState([]);
  const [linkssales, setLinkssales] = useState([]);
  const [totalrecsales, setTotalrecsales] = useState(0);
  const [perpagesales, setPerpagesales] = useState(10);
  const [keywordsales, setKeywordsales] = useState('');

  const [comm, setComm] = useState([]);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);


  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);


  const [showCalendarComm, setShowCalendarComm] = useState(false);
  const [selectedRangeComm, setSelectedRangeComm] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);


  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedRange, setSelectedRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [selectedRangeStartMer, setSelectedRangeStartMer] = useState('');
  const [selectedRangeEndMer, setSelectedRangeEndMer] = useState('');

  const [showCalendarMer, setShowCalendarMer] = useState(false);
  const [selectedRangeMer, setSelectedRangeMer] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [selectedRangeStartSales, setSelectedRangeStartSales] = useState('');
  const [selectedRangeEndSales, setSelectedRangeEndSales] = useState('');

  const [showCalendarSales, setShowCalendarSales] = useState(false);
  const [selectedRangeSales, setSelectedRangeSales] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [isMobile, setIsMobile] = useState(false);
  const [emAccordionOpen, setemAccordionOpen] = useState(false);
  const [payAccordionOpen, setPayAccordionOpen] = useState(false);
  const [payAccordionOpens, setPayAccordionOpens] = useState(false);

  useEffect(() => {
    document.title = `Salesperson-Information | bluefaucet`;
    document.getElementById("bodywrap").className = "infr";
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    API.post('backoffice_sales_profile', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setInputs(
            {
              id: response.data.data.id,
              name: response.data.data.name,
              mobile: response.data.data.mobile,
              email: response.data.data.email,
              city: response.data.data.city,
              state: response.data.data.state,
              zip_code: response.data.data.zip_code,
              street_name: response.data.data.street_name,
              w_2_status: response.data.data.w_2_status,
              payment_setup: response.data.data.payment_setup,
              profile: response.data.data.profile,
              earned_commission: response.data.data.earned_commission,
              withdrawal: response.data.data.withdrawal,
              referred_id: response.data.data.referred_id,
              referred_name: response.data.data.referred_name
            });
          const earned = response.data.data.chart.earned.map(item => item.value);
          const withdraw = response.data.data.chart.withdraw.map(item => item.value);
          // Assuming both arrays are the same length, or pad shorter ones with null/0
          const maxLength = Math.max(earned.length, withdraw.length);
          const mergedData = Array.from({ length: maxLength }).map((_, i) => ({
            earned: earned[i] ?? 0,     // Use 0 if no value exists
            withdraw: withdraw[i] ?? 0,
          }));
          setMergeddata(mergedData);

          var url = process.env.REACT_APP_BASE_URL_BLUEFAUCET + 'mer-store-setup?key=' + response.data.data.token + '&type=direct';
          setInputslnk({ url: url });


        }
      }).catch(error => {
        setLoading(false);
      });


    let formData1 = new FormData();
    formData1.append('token', localStorage.getItem("token"));
    formData1.append('id', id);
    formData1.append('per_page', 10);
    formData1.append('page', 1);
    formData1.append('order_by', 'asc');
    API.post('backoffice_sales_invited_merchants', formData1)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setInvitedmerchants(response.data.data.data);
          setLinksmer(response.data.data.links);
          setTotalrecmer(response.data.data.total);
        }
      }).catch(error => {
        setLoading(false);
      });

    let formData2 = new FormData();
    formData2.append('token', localStorage.getItem("token"));
    formData2.append('id', id);
    formData2.append('per_page', 10);
    formData2.append('page', 1);
    formData2.append('order_by', 'asc');
    API.post('backoffice_sales_invited_sales', formData2)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setSales(response.data.data.data);
          setLinkssales(response.data.data.links);
          setTotalrecsales(response.data.data.total);
        }
      }).catch(error => {
        setLoading(false);
      });


    let formData3 = new FormData();
    formData3.append('token', localStorage.getItem("token"));
    formData3.append('id', id);
    API.post('backoffice_sales_commission_and_withdraw_information', formData2)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setComm(response.data.data);

        }
      }).catch(error => {
        setLoading(false);
      });

    const handleResize = () => {
      setIsMobile(window.innerWidth < 767);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [id]);

  const handleSelect = (ranges) => {
    setSelectedRange([ranges.selection]);
  };
  const closeCalendar = () => {
    setShowCalendar(false);
    setLoading(true);

    var start_date = moment(selectedRange[0].startDate).format('YYYY-MM-DD');
    var end_date = moment(selectedRange[0].endDate).format('YYYY-MM-DD');

    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('start_date', start_date);
    formData.append('end_date', end_date);
    API.post('backoffice_sales_profile', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setInputs(
            {
              id: response.data.data.id,
              name: response.data.data.name,
              mobile: response.data.data.mobile,
              email: response.data.data.email,
              state: response.data.data.state,
              street_name: response.data.data.street_name,
              w_2_status: response.data.data.w_2_status,
              payment_setup: response.data.data.payment_setup,
              profile: response.data.data.profile,
              earned_commission: response.data.data.earned_commission,
              withdrawal: response.data.data.withdrawal
            });
          const earned = response.data.data.chart.earned.map(item => item.value);
          const withdraw = response.data.data.chart.withdraw.map(item => item.value);

          // Assuming both arrays are the same length, or pad shorter ones with null/0
          const maxLength = Math.max(earned.length, withdraw.length);
          const mergedData = Array.from({ length: maxLength }).map((_, i) => ({
            earned: earned[i] ?? 0,     // Use 0 if no value exists
            withdraw: withdraw[i] ?? 0,
          }));
          setMergeddata(mergedData);
        }
      }).catch(error => {
        setLoading(false);
      });
  }

  const handleRowsChangeMer = (e) => {
    setLoading(true);
    var perpage = parseInt(e.target.value);
    setPerpage(perpage);

    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', perpage);
    formData.append('page', 1);
    formData.append('order_by', "asc");
    formData.append('keyword', keyword);
    if (selectedRangeStartMer !== '' && selectedRangeEndMer !== '') {
      var start_date = moment(selectedRangeStartMer).format('YYYY-MM-DD');
      var end_date = moment(selectedRangeEndMer).format('YYYY-MM-DD');
      formData.append('start_date', start_date);
      formData.append('end_date', end_date);
    }
    API.post('backoffice_sales_invited_merchants', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setInvitedmerchants(response.data.data.data);
          setLinksmer(response.data.data.links);
          setTotalrecmer(response.data.data.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handlePageChangeMer = (page) => {
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', perpage);
    formData.append('page', page);
    formData.append('order_by', 'asc');
    formData.append('keyword', keyword);
    if (selectedRangeStartMer !== '' && selectedRangeEndMer !== '') {
      var start_date = moment(selectedRangeStartMer).format('YYYY-MM-DD');
      var end_date = moment(selectedRangeEndMer).format('YYYY-MM-DD');
      formData.append('start_date', start_date);
      formData.append('end_date', end_date);
    }
    API.post('backoffice_sales_invited_merchants', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setInvitedmerchants(response.data.data.data);
          setLinksmer(response.data.data.links);
          setTotalrecmer(response.data.data.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handleInputChangeMer = (event) => {
    var keyword = event.target.value;
    setKeyword(keyword);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', perpage);
    formData.append('page', 1);
    formData.append('order_by', "asc");
    formData.append('keyword', keyword);
    if (selectedRangeStartMer !== '' && selectedRangeEndMer !== '') {
      var start_date = moment(selectedRangeStartMer).format('YYYY-MM-DD');
      var end_date = moment(selectedRangeEndMer).format('YYYY-MM-DD');
      formData.append('start_date', start_date);
      formData.append('end_date', end_date);
    }
    API.post('backoffice_sales_invited_merchants', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setInvitedmerchants(response.data.data.data);
          setLinksmer(response.data.data.links);
          setTotalrecmer(response.data.data.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  }
  const handleSelectMer = (ranges) => {
    setSelectedRangeMer([ranges.selection]);
    setSelectedRangeStartMer(ranges.selection.startDate);
    setSelectedRangeEndMer(ranges.selection.endDate);
  };
  const closeCalendarMer = () => {
    setShowCalendarMer(false);
    setLoading(true);

    var start_date = moment(selectedRangeMer[0].startDate).format('YYYY-MM-DD');
    var end_date = moment(selectedRangeMer[0].endDate).format('YYYY-MM-DD');

    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', perpage);
    formData.append('page', 1);
    formData.append('order_by', "asc");
    formData.append('keyword', keyword);
    formData.append('start_date', start_date);
    formData.append('end_date', end_date);
    API.post('backoffice_sales_invited_merchants', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setInvitedmerchants(response.data.data.data);
          setLinksmer(response.data.data.links);
          setTotalrecmer(response.data.data.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  }
  const handleRowsChangeSales = (e) => {
    setLoading(true);
    var perpage = parseInt(e.target.value);
    setPerpagesales(perpage);

    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', perpage);
    formData.append('page', 1);
    formData.append('order_by', "asc");
    formData.append('keyword', keywordsales);
    if (selectedRangeStartSales !== '' && selectedRangeEndSales !== '') {
      var start_date = moment(selectedRangeStartSales).format('YYYY-MM-DD');
      var end_date = moment(selectedRangeEndSales).format('YYYY-MM-DD');
      formData.append('start_date', start_date);
      formData.append('end_date', end_date);
    }
    API.post('backoffice_sales_invited_sales', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setSales(response.data.data.data);
          setLinkssales(response.data.data.links);
          setTotalrecsales(response.data.data.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handlePageChangeSales = (page) => {
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', perpagesales);
    formData.append('page', page);
    formData.append('order_by', 'asc');
    formData.append('keyword', keywordsales);
    if (selectedRangeStartSales !== '' && selectedRangeEndSales !== '') {
      var start_date = moment(selectedRangeStartSales).format('YYYY-MM-DD');
      var end_date = moment(selectedRangeEndSales).format('YYYY-MM-DD');
      formData.append('start_date', start_date);
      formData.append('end_date', end_date);
    }
    API.post('backoffice_sales_invited_sales', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setSales(response.data.data.data);
          setLinkssales(response.data.data.links);
          setTotalrecsales(response.data.data.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handleInputChangeSales = (event) => {
    var keyword = event.target.value;
    setKeywordsales(keyword);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', perpagesales);
    formData.append('page', 1);
    formData.append('order_by', "asc");
    formData.append('keyword', keyword);
    if (selectedRangeStartSales !== '' && selectedRangeEndSales !== '') {
      var start_date = moment(selectedRangeStartSales).format('YYYY-MM-DD');
      var end_date = moment(selectedRangeEndSales).format('YYYY-MM-DD');
      formData.append('start_date', start_date);
      formData.append('end_date', end_date);
    }
    API.post('backoffice_sales_invited_sales', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setSales(response.data.data.data);
          setLinkssales(response.data.data.links);
          setTotalrecsales(response.data.data.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  }
  const handleSelectSales = (ranges) => {
    setSelectedRangeSales([ranges.selection]);
    setSelectedRangeStartSales(ranges.selection.startDate);
    setSelectedRangeEndSales(ranges.selection.endDate);
  };
  const closeCalendarSales = () => {
    setShowCalendarSales(false);
    setLoading(true);
    var start_date = moment(selectedRangeSales[0].startDate).format('YYYY-MM-DD');
    var end_date = moment(selectedRangeSales[0].endDate).format('YYYY-MM-DD');

    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', perpagesales);
    formData.append('page', 1);
    formData.append('order_by', "asc");
    formData.append('keyword', keywordsales);
    formData.append('start_date', start_date);
    formData.append('end_date', end_date);
    API.post('backoffice_sales_invited_sales', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setSales(response.data.data.data);
          setLinkssales(response.data.data.links);
          setTotalrecsales(response.data.data.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  }

  const handleSelectComm = (ranges) => {
    setSelectedRangeComm([ranges.selection]);
  };
  const closeCalendarComm = () => {
    setShowCalendarComm(false);
    setLoading(true);

    var start_date = moment(selectedRangeComm[0].startDate).format('YYYY-MM-DD');
    var end_date = moment(selectedRangeComm[0].endDate).format('YYYY-MM-DD');

    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('start_date', start_date);
    formData.append('end_date', end_date);
    API.post('backoffice_sales_commission_and_withdraw_information', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setComm(response.data.data);
        }
      }).catch(error => {
        setLoading(false);
      });
  }

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Sidebar />
          <div className="col-md-9 col-lg-9 col-xl-10 col-xxl-10 ">
            <Header />
            <div className="row">
              <div className="content">
                <div className="row">
                  <div className="col-12">
                    <div className="d-flex align-items-center justify-content-between koji mb-4">
                      <h1>Salesperson Profile</h1>
                      <Link to={process.env.REACT_APP_BASE_URL + "dashboard-sales-vp-of-sales-representative"} className="text-decoration-none">View Details</Link>
                    </div>
                    <div className="vnfro shadow-none">
                      <div className="d-flex align-items-start justify-content-between flex-wrap kjuk gap-3">
                        {/* Profile Image */}
                        <div className="d-flex align-items-start gap-3">
                          <div className="sales-img flex-shrink-0">

                            {inputs.profile !== '' ? <img
                              src={inputs.profile}
                              alt="Profile"
                              className="img-fluid"
                            /> : <img
                              src={process.env.REACT_APP_BASE_URL + 'assests/images/place_image.png'}
                              alt="Profile"
                              className="img-fluid"
                            />}
                          </div>
                          {/* Store Info */}
                          <div className="infea fgfxzr mb-md-0">
                            <h5>{inputs.name} <div className="oky">&mdash; Salesperson</div></h5>
                            <div className="d-flex gap-3 mb-2 opi">
                              <div className="ids d-flex">Ph #:<div className="okk"> {inputs.mobile}</div> </div>
                              <div className="date d-flex">Email: <div className="okk"> {inputs.email}</div> </div>
                            </div>
                            <div className="d-flex gap-3 mb-2 opis">
                              <div className="date d-flex">Territories: <div className="okk">{inputs.state}</div> </div>
                              <div className="date d-flex">Zoom: <div className="okk"> --</div></div>
                            </div>
                            <div className="date oji mb-3">
                              <span className="date me-0">Mailing Address: </span>
                              <span className="okk">
                                {inputs.city || inputs.state || inputs.zip_code
                                  ? [inputs.city, inputs.state, inputs.zip_code].filter(Boolean).join(', ')
                                  : 'N/A'}
                              </span>
                            </div>

                            <div className="d-flex gap-3 mb-2 d-none d-md-flex">
                              <div className="date d-flex">W-9 Status: <div className="okk">{inputs.w_2_status ? "Available" : "Not Available"} </div> </div>
                              <div className="date d-flex">Payment Setup: <div className="okk"> {inputs.payment_setup ? "Stripe Account" : "N/A"} </div></div>
                            </div>
                            <div className="d-flex gap-3 mb-2 d-none d-md-flex">
                              <div className="date d-flex"><Link className="d-none d-md-flex mb-0" to="#" onClick={handleShow1}>QR Code</Link></div>
                              {inputs.referred_name && (
                                <div className="date d-flex">
                                  Referral Name:
                                  <div className="okk">
                                    <Link to={
                                      process.env.REACT_APP_BASE_URL +
                                      "salesperson-Information/" + inputs.referred_id
                                    } className="text-decoration-none">{inputs.referred_name}</Link>
                                  </div>
                                </div>
                              )}
                            </div>

                            {/*<div className="date oji mb-3">
                              <span className="date me-0">Account Holder Name: </span>
                              <span className="okk">Yash</span>
                            </div>

                            <div className="date oji mb-3">
                              <span className="date me-0">Routing Number: </span>
                              <span className="okk">110000000</span>
                            </div>

                            <div className="date oji mb-3">
                              <span className="date me-0">Account Number: </span>
                              <span className="okk">000123456789</span>
                            </div>*/}

                          </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-end">
                          <div style={{
                            borderRadius: '20px',
                            padding: '20px',
                            border: '1px solid #EFF0F6',
                            width: '100%',
                            background: '#F8FAFC'
                          }}>
                            {/* <div className="mb-3 d-flex align-items-center justify-content-end" style={{ position: 'relative' }}>
                                <input
                                  type="date"
                                  value={selectedDate}
                                  onChange={handleDateChange}
                                  style={{
                                    border: '1px solid #154D99',
                                    background: '#F8FAFC',
                                    borderRadius: '6px',
                                    padding: '8px',
                                    fontSize: '12px',
                                    appearance: 'none',
                                    WebkitAppearance: 'none',
                                    MozAppearance: 'none',
                                    cursor: 'pointer',
                                    width: '100px'
                                  }}
                                />
                            </div> */}
                            <div className="mb-3 d-flex align-items-center justify-content-end" style={{ position: 'relative' }}>
                              {/* Trigger Button */}
                              <button
                                className="btn canu"
                                onClick={() => setShowCalendar(true)}
                              >
                                {selectedRange[0].startDate.toLocaleDateString()} -{" "}
                                {selectedRange[0].endDate.toLocaleDateString()}{" "}
                                <i className="bi bi-calendar"></i>
                              </button>
                              {/* Calendar Popup */}
                              {showCalendar && (
                                <div
                                  className="calendar-popup-overlay"
                                  onClick={closeCalendar}
                                  style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: "rgba(0,0,0,0.3)",
                                    zIndex: 9999,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    className="calendar-popup-content"
                                    onClick={(e) => e.stopPropagation()}
                                    style={{
                                      backgroundColor: "#fff",
                                      padding: "20px",
                                      borderRadius: "8px",
                                      maxWidth: "855px",
                                      width: "100%",
                                      boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                                    }}
                                  >
                                    <DateRangePicker
                                      onChange={handleSelect}
                                      showSelectionPreview={true}
                                      moveRangeOnFirstSelection={false}
                                      months={2}
                                      ranges={selectedRange}
                                      direction="horizontal"
                                      locale={enUS}
                                    />
                                    <div className="text-end mt-3">
                                      <button className="btn done-btn" onClick={closeCalendar}>
                                        Done
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '12px' }}>
                              <div>
                                <div className="chap" style={{ fontSize: "14px", color: "#444", marginBottom: "4px" }}>
                                  Earned Commission
                                </div>
                                <div className="rakam">
                                  ${inputs.earned_commission}
                                </div>
                              </div>
                              <div>
                                <div className="chap" style={{ fontSize: "14px", color: "#444", marginBottom: "4px" }}>
                                  Withdraw Commission
                                </div>
                                <div className="rakam">
                                  ${inputs.withdrawal}
                                </div>
                              </div>
                            </div>
                            <div style={{ height: '111px' }}>
                              <ResponsiveContainer width="100%" height="100%">
                                <AreaChart data={mergeddata}>
                                  <defs>
                                    <linearGradient id="earnedGradient" x1="0" y1="0" x2="0" y2="1">
                                      <stop offset="0%" stopColor="#0062FF" stopOpacity={1} />
                                      <stop offset="100%" stopColor="#ffffff" stopOpacity={0} />
                                    </linearGradient>
                                  </defs>
                                  <Area
                                    type="monotone"
                                    dataKey="earned"
                                    stroke="#0D4796"
                                    fill="url(#earnedGradient)"
                                    strokeWidth={2}
                                  />
                                  <Area
                                    type="monotone"
                                    dataKey="withdraw"
                                    stroke="#B49849"
                                    fill="url(#withdrawGradient)"
                                    strokeWidth={2}
                                  />
                                </AreaChart>
                              </ResponsiveContainer>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 holisti mt-4 okhas">
                    <Card className="h-100">
                      <div className="d-none d-md-flex flex-column-reverse flex-md-row justify-content-between align-items-md-center">
                        <Card.Title className="d-none d-md-block">Commission and withdraw Information </Card.Title>
                        <div className="d-none d-md-block">
                          <div>
                            {/* Trigger Button */}
                            <button
                              className="btn canu"
                              onClick={() => setShowCalendarComm(true)}
                            >
                              {selectedRangeComm[0].startDate.toLocaleDateString()} -{" "}
                              {selectedRangeComm[0].endDate.toLocaleDateString()}{" "}
                              <i className="bi bi-calendar"></i>
                            </button>
                            {/* Calendar Popup */}
                            {showCalendarComm && (
                              <div
                                className="calendar-popup-overlay"
                                onClick={closeCalendarComm}
                                style={{
                                  position: "fixed",
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  bottom: 0,
                                  backgroundColor: "rgba(0,0,0,0.3)",
                                  zIndex: 9999,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  className="calendar-popup-content"
                                  onClick={(e) => e.stopPropagation()}
                                  style={{
                                    backgroundColor: "#fff",
                                    padding: "20px",
                                    borderRadius: "8px",
                                    maxWidth: "855px",
                                    width: "100%",
                                    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                                  }}
                                >
                                  <DateRangePicker
                                    onChange={handleSelectComm}
                                    showSelectionPreview={true}
                                    moveRangeOnFirstSelection={false}
                                    months={2}
                                    ranges={selectedRangeComm}
                                    direction="horizontal"
                                    locale={enUS}
                                  />
                                  <div className="text-end mt-3">
                                    <button className="btn done-btn" onClick={closeCalendarComm}>
                                      Done
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="table-ro mt-2 d-none d-md-block">
                        <Table responsive className="table-no-last-border mb-0">
                          <thead className="table">
                            <tr className="custom-header">
                              <th className="lft">Date</th>
                              <th>Pending Release Date</th>
                              <th>Transaction Details</th>
                              <th>Merchant ID / Sales ID </th>
                              <th>Deposite</th>
                              <th>Withdraw</th>
                              <th>Balance</th>

                            </tr>
                          </thead>
                          <tbody>
                            {comm.map((item, index) => (
                              <tr key={index}>
                                <td className="lef">{item.date}</td>
                                <td>{item.wallet_add_date ? `${item.wallet_add_date}` : '-'}</td>
                                <td>{item.transaction_detail}</td>
                                <td>{item.name ? item.name : '-'}</td>
                                <td>{item.deposit ? `$${item.deposit}` : '-'}</td>
                                <td>{item.withdraw ? `$${item.withdraw}` : '-'}</td>
                                <td>{item.balance ? `$${item.balance}` : '-'}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                      <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
                        onClick={() => isMobile && setemAccordionOpen(!emAccordionOpen)}
                        style={{ cursor: isMobile ? "pointer" : "default" }}
                      >
                        <h5>Commission and withdraw Information</h5>
                        {isMobile && (
                          <img
                            src={
                              process.env.REACT_APP_BASE_URL +
                              (emAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                            }
                            alt="Toggle Arrow"
                          />
                        )}
                      </div>
                      {(!isMobile || emAccordionOpen) && (
                        <>
                          <div className="d-block d-md-none">
                            <div className="d-flex align-items-center justify-content-end">
                              <div>
                                {/* Trigger Button */}
                                <button
                                  className="btn canu"
                                  onClick={() => setShowCalendar(true)}
                                >
                                  {selectedRange[0].startDate.toLocaleDateString()} -{" "}
                                  {selectedRange[0].endDate.toLocaleDateString()}{" "}
                                  <i className="bi bi-calendar"></i>
                                </button>

                                {/* Calendar Popup */}
                                {showCalendar && (
                                  <div
                                    className="calendar-popup-overlay"
                                    onClick={closeCalendar}
                                    style={{
                                      position: "fixed",
                                      top: 0,
                                      left: 0,
                                      right: 0,
                                      bottom: 0,
                                      backgroundColor: "rgba(0,0,0,0.3)",
                                      zIndex: 9999,
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      className="calendar-popup-content"
                                      onClick={(e) => e.stopPropagation()}
                                      style={{
                                        backgroundColor: "#fff",
                                        padding: "20px",
                                        borderRadius: "8px",
                                        maxWidth: "855px",
                                        width: "100%",
                                        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      <DateRangePicker
                                        onChange={handleSelect}
                                        showSelectionPreview={true}
                                        moveRangeOnFirstSelection={false}
                                        months={2}
                                        ranges={selectedRange}
                                        direction="horizontal"
                                        locale={enUS}
                                      />
                                      <div className="text-end mt-3">
                                        <button className="btn done-btn" onClick={closeCalendar}>
                                          Done
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="d-md-none mb-3 ev-mobilex kocho">
                            {comm.map((item, index) => (
                              <div
                                key={index}
                                className="col-12 mb-3 main"
                              >
                                {/* Top row: Join date and Active tag */}
                                <div className="d-flex justify-content-between align-items-center fir mb-3">
                                  <div className="joilsyx2">{item.date}</div>
                                  <div className="joilsyx2">Transaction Details {item.transaction_detail}</div>
                                </div>

                                <div className="d-flex justify-content-between align-items-center fir mb-3">
                                  <div className="joilsyh7">{item.name}</div>

                                </div>

                                <div className="row ojuxi">
                                  <div className="col-4">
                                    <h2>Deposite</h2>
                                    <h3>{item.deposit ? `$${item.deposit}` : '-'}</h3>
                                  </div>
                                  <div className="col-4">
                                    <h2>Withdraw</h2>
                                    <h3>{item.withdraw ? `$${item.withdraw}` : '-'}</h3>
                                  </div>
                                  <div className="col-4">
                                    <h2>Balance</h2>
                                    <h3>{item.balance ? `$${item.balance}` : '-'}</h3>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>

                        </>
                      )}
                    </Card>
                  </div>
                  <div className="col-12 holisti mt-4 okhas">
                    <Card className="h-100">
                      <div className="d-flex flex-column-reverse flex-md-row justify-content-between align-items-md-center">
                        <Card.Title className="d-none d-md-block">Invited Merchants </Card.Title>
                        <div className="d-flex align-items-center gap-3 mb-2 mb-lg-0">
                          <div className="d-flex align-items-center gap-3 w-100 justify-content-md-start w-md-auto">
                            <div>
                              {/* Trigger Button */}
                              <button
                                className="btn canu"
                                onClick={() => setShowCalendarMer(true)}
                              >
                                {selectedRangeMer[0].startDate.toLocaleDateString()} -{" "}
                                {selectedRangeMer[0].endDate.toLocaleDateString()}{" "}
                                <i className="bi bi-calendar"></i>
                              </button>

                              {/* Calendar Popup */}
                              {showCalendarMer && (
                                <div
                                  className="calendar-popup-overlay"
                                  onClick={closeCalendarMer}
                                  style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: "rgba(0,0,0,0.3)",
                                    zIndex: 9999,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    className="calendar-popup-content"
                                    onClick={(e) => e.stopPropagation()}
                                    style={{
                                      backgroundColor: "#fff",
                                      padding: "20px",
                                      borderRadius: "8px",
                                      maxWidth: "855px",
                                      width: "100%",
                                      boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                                    }}
                                  >
                                    <DateRangePicker
                                      onChange={handleSelectMer}
                                      showSelectionPreview={true}
                                      moveRangeOnFirstSelection={false}
                                      months={2}
                                      ranges={selectedRangeMer}
                                      direction="horizontal"
                                      locale={enUS}
                                    />
                                    <div className="text-end mt-3">
                                      <button className="btn done-btn" onClick={closeCalendarMer}>
                                        Done
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="flex-grow-1">
                              <div className="input-group optional">
                                <div className="input-group-text border-end-0">
                                  <img
                                    src={process.env.REACT_APP_BASE_URL + 'assests/images/search.png'}
                                    alt="Search Icon"
                                    className="img-fluid"
                                  />
                                </div>
                                <input
                                  type="text"
                                  className="form-control border-start-0"
                                  placeholder="Search"
                                  value={keyword}
                                  onChange={handleInputChangeMer}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="table-ro mt-2 d-none d-md-block">
                        <Table
                          responsive
                          className="table-no-last-border mb-0"
                        >
                          <thead className="table">
                            <tr className="custom-header">
                              <th className="lft">Join Date</th>
                              <th>Store Name</th>
                              <th>Owner Name</th>
                              <th>Phone No.</th>
                              <th>Email</th>
                              <th>Address</th>

                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {invitedmerchants.map((item, index) => (
                              <tr key={index}>
                                <td className="lef">{item.join_date}</td>
                                <td><Link to={process.env.REACT_APP_BASE_URL + 'merchant-subscription/' + item.store_id}>{item.name}</Link></td>
                                <td>{item.owner_name}</td>
                                <td>{item.mobile}</td>
                                <td>{item.email}</td>
                                <td>{item.city}, {item.state}, {item.zip_code}</td>
                                <td className="ref">{item.status_name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                      <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
                        onClick={() => isMobile && setPayAccordionOpen(!payAccordionOpen)}
                        style={{ cursor: isMobile ? "pointer" : "default" }}
                      >
                        <h5>Invited Merchants</h5>
                        {isMobile && (
                          <img
                            src={
                              process.env.REACT_APP_BASE_URL +
                              (payAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                            }
                            alt="Toggle Arrow"
                          />
                        )}
                      </div>
                      {(!isMobile || payAccordionOpen) && (
                        <>
                          <div className="d-md-none mb-3 ev-mobilex koma">
                            {invitedmerchants.map((item, index) => (
                              <div
                                key={index}
                                className="col-12 mb-3 main"
                              >
                                <div className="d-flex justify-content-between mb-3">
                                  <div className="joily d-flex">
                                    <div className="date">{item.join_date} -</div> Join Date
                                  </div>
                                  <div className="jghyu7w3">{item.status_name}</div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <div className="stoling d-flex align-items-center"><img src={process.env.REACT_APP_BASE_URL + 'assests/images/homly.png'} alt="" className="img-fluid" /><Link to={process.env.REACT_APP_BASE_URL + 'merchant-subscription/' + item.store_id} className="table-link">{item.name}</Link></div>
                                  <div className="income">{item.owner_name}</div>
                                </div>

                                <div className="phony d-flex align-items-center mb-2"><img src={process.env.REACT_APP_BASE_URL + 'assests/images/emiyy.png'} alt={item.name} className="me-2" />{item.email}</div>
                                <div className="phony d-flex align-items-center mb-2"><img src={process.env.REACT_APP_BASE_URL + 'assests/images/phonty.png'} alt={item.name} className="me-2" />{item.mobile}</div>
                                <div className="phony d-flex align-items-center mb-3"><img src={process.env.REACT_APP_BASE_URL + 'assests/images/location.png'} alt={item.name} className="me-2" />{item.street_name}</div>
                                <div className="details">
                                  <div className="avatar-group">
                                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/avatar1.png'} alt="avatar" className="avatar-img" />
                                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/avatar2.png'} alt="avatar" className="avatar-img" />
                                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/avatar3.png'} alt="avatar" className="avatar-img" />
                                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/avatar4.png'} alt="avatar" className="avatar-img" />
                                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/avatar5.png'} alt="avatar" className="avatar-img" />
                                    <div className="avatar-extra">+418</div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation">
                            <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex chelu">
                              <label>Show rows:</label>
                              <select
                                value={perpage}
                                onChange={handleRowsChangeMer}
                                className="form-select w-auto"
                              >
                                <option value={10}>10 items</option>
                                <option value={15}>15 items</option>
                                <option value={20}>20 items</option>
                                <option value={25}>25 items</option>
                              </select>
                            </div>
                            {totalrecmer > 0 && (
                              <nav>
                                <ul className="pagination pagination-sm mb-0">

                                  {linksmer.map((link, index) => {
                                    var label = link.label;
                                    if (label.includes("Previous")) label = "<";
                                    if (label.includes("Next")) label = ">";

                                    return (
                                      <>
                                        <li className={`page-item ${link.active ? "active" : ""}`}>
                                          <button
                                            className={`page-link ${!link.url ? "disabled" : ""}`}
                                            onClick={() => {
                                              if (link.url) {
                                                const pageNumber = new URLSearchParams(link.url.split("?")[1]).get("page");
                                                handlePageChangeMer(pageNumber);
                                              }
                                            }}

                                          >
                                            {label}
                                          </button>
                                        </li>
                                      </>
                                    );
                                  })}
                                </ul>
                              </nav>
                            )}
                          </div>
                        </>
                      )}
                    </Card>
                  </div>

                  <div className="col-12 holisti mt-4 okhas">
                    <Card className="h-100">
                      <div className="d-flex flex-column-reverse flex-md-row justify-content-between align-items-md-center">
                        <Card.Title className="d-none d-md-block">Sales and Status </Card.Title>
                        <div className="d-flex align-items-center gap-3 mb-2 mb-lg-0">
                          <div className="d-flex align-items-center gap-3 w-100 justify-content-md-start w-md-auto">
                            <div>
                              {/* Trigger Button */}
                              <button
                                className="btn canu"
                                onClick={() => setShowCalendarSales(true)}
                              >
                                {selectedRangeSales[0].startDate.toLocaleDateString()} -{" "}
                                {selectedRangeSales[0].endDate.toLocaleDateString()}{" "}
                                <i className="bi bi-calendar"></i>
                              </button>

                              {/* Calendar Popup */}
                              {showCalendarSales && (
                                <div
                                  className="calendar-popup-overlay"
                                  onClick={closeCalendarSales}
                                  style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: "rgba(0,0,0,0.3)",
                                    zIndex: 9999,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    className="calendar-popup-content"
                                    onClick={(e) => e.stopPropagation()}
                                    style={{
                                      backgroundColor: "#fff",
                                      padding: "20px",
                                      borderRadius: "8px",
                                      maxWidth: "855px",
                                      width: "100%",
                                      boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                                    }}
                                  >
                                    <DateRangePicker
                                      onChange={handleSelectSales}
                                      showSelectionPreview={true}
                                      moveRangeOnFirstSelection={false}
                                      months={2}
                                      ranges={selectedRangeSales}
                                      direction="horizontal"
                                      locale={enUS}
                                    />
                                    <div className="text-end mt-3">
                                      <button className="btn done-btn" onClick={closeCalendarSales}>
                                        Done
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="flex-grow-1">
                              <div className="input-group optional">
                                <div className="input-group-text border-end-0">
                                  <img
                                    src={process.env.REACT_APP_BASE_URL + 'assests/images/search.png'}
                                    alt="Search Icon"
                                    className="img-fluid"
                                  />
                                </div>
                                <input
                                  type="text"
                                  className="form-control border-start-0"
                                  placeholder="Search"
                                  value={keywordsales}
                                  onChange={handleInputChangeSales}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="table-ro mt-2 d-none d-md-block">
                        <Table
                          responsive
                          className="table-no-last-border mb-0"
                        >
                          <thead className="table">
                            <tr className="custom-header">
                              <th className="lft">Join Date</th>
                              <th>Sales Name</th>
                              <th>Phone No.</th>
                              <th>Email</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sales.map((item, index) => (
                              <tr key={index}>
                                <td className="lef">{item.join_date}</td>
                                <td><Link to={process.env.REACT_APP_BASE_URL + 'salesperson-Information/' + item.id}>{item.sales_name}</Link></td>
                                <td>{item.mobile}</td>
                                <td>{item.email}</td>
                                <td className="ref">{item.status_name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                      <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
                        onClick={() => isMobile && setPayAccordionOpens(!payAccordionOpens)}
                        style={{ cursor: isMobile ? "pointer" : "default" }}
                      >
                        <h5>Sales and Status</h5>
                        {isMobile && (
                          <img
                            src={
                              process.env.REACT_APP_BASE_URL +
                              (payAccordionOpens ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                            }
                            alt="Toggle Arrow"
                          />
                        )}
                      </div>
                      {(!isMobile || payAccordionOpens) && (
                        <>
                          <div className="d-md-none mb-3 ev-mobilex koma">
                            {sales.map((item, index) => (
                              <div
                                key={index}
                                className="col-12 mb-3 main"
                              >
                                <div className="d-flex justify-content-between mb-3">
                                  <div className="joily d-flex">
                                    <div className="date">{item.join_date} -</div> Join Date
                                  </div>
                                  <div className="jghyu7w3">{item.status_name}</div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <div className="stoling d-flex align-items-center"><img src={process.env.REACT_APP_BASE_URL + 'assests/images/homly.png'} alt="" className="img-fluid" /><Link to={process.env.REACT_APP_BASE_URL + 'salesperson-Information/' + item.id} className="table-link">{item.sales_name}</Link></div>

                                </div>

                                <div className="phony d-flex align-items-center mb-2"><img src={process.env.REACT_APP_BASE_URL + 'assests/images/emiyy.png'} alt={item.sales_name} className="me-2" />{item.email}</div>
                                <div className="phony d-flex align-items-center mb-2"><img src={process.env.REACT_APP_BASE_URL + 'assests/images/phonty.png'} alt={item.sales_name} className="me-2" />{item.mobile}</div>

                                <div className="details">
                                  <div className="avatar-group">
                                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/avatar1.png'} alt="avatar" className="avatar-img" />
                                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/avatar2.png'} alt="avatar" className="avatar-img" />
                                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/avatar3.png'} alt="avatar" className="avatar-img" />
                                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/avatar4.png'} alt="avatar" className="avatar-img" />
                                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/avatar5.png'} alt="avatar" className="avatar-img" />
                                    <div className="avatar-extra">+418</div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation">
                            <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex chelu">
                              <label>Show rows:</label>
                              <select
                                value={perpagesales}
                                onChange={handleRowsChangeSales}
                                className="form-select w-auto"
                              >
                                <option value={10}>10 items</option>
                                <option value={15}>15 items</option>
                                <option value={20}>20 items</option>
                                <option value={25}>25 items</option>
                              </select>
                            </div>
                            {totalrecsales > 0 && (
                              <nav>
                                <ul className="pagination pagination-sm mb-0">

                                  {linkssales.map((link, index) => {
                                    var label = link.label;
                                    if (label.includes("Previous")) label = "<";
                                    if (label.includes("Next")) label = ">";

                                    return (
                                      <>
                                        <li className={`page-item ${link.active ? "active" : ""}`}>
                                          <button
                                            className={`page-link ${!link.url ? "disabled" : ""}`}
                                            onClick={() => {
                                              if (link.url) {
                                                const pageNumber = new URLSearchParams(link.url.split("?")[1]).get("page");
                                                handlePageChangeSales(pageNumber);
                                              }
                                            }}

                                          >
                                            {label}
                                          </button>
                                        </li>
                                      </>
                                    );
                                  })}
                                </ul>
                              </nav>
                            )}
                          </div>
                        </>
                      )}
                    </Card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal centered show={show} onHide={handleClose} className="ps-0" size="lg">
        <Modal.Body className="p-0">
          <Col md={12} xs={12}>
            <div className="col-12 holisti">
              <Card className="h-100">
                <div className="table-ro">
                  <Table
                    responsive
                    className="table-no-last-border mb-0"
                  >
                    <thead className="table">
                      <tr className="custom-header">
                        <th className="lft">Date</th>
                        <th>Amount</th>
                        <th>Transaction Number</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactions.map((item, index) => (
                        <tr key={index}>
                          <td>{item.date}</td>
                          <td>{item.amount}</td>
                          <td>{item.txnNumber}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Card>
            </div>
          </Col>
        </Modal.Body>
      </Modal>

      <Modal show={show1} onHide={handleClose1} className="popupwrngcnt">
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <Col md={12} xs={12} className="mb-3 sercpop text-center">
            <QRCodeSVG
              value={inputslnk.url}
              width={200}
              height={200}
            />
          </Col>
        </Modal.Body>
      </Modal>

      {loading && (
        <div className="loadingClass">
          <img src={loader} alt="loader" />
        </div>
      )}
    </>
  );
};

export default SalespersonInformation;